module.exports = __webpack_public_path__ + "static/media/save.edb15830.svg";